var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUndiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 31,
    viewBox: "0 0 63 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3089 0H20.5084V16.067C20.5084 19.112 17.8915 21.5759 14.6492 21.5759C11.4069 21.5759 8.79004 19.112 8.79004 16.067V0H0V16.067C0 16.1445 0 16.2194 0 16.2969C0 23.9055 6.55786 30.0705 14.6544 30.0705C22.751 30.0705 29.3089 23.9055 29.3089 16.2969C29.3089 16.2194 29.3089 16.1445 29.3089 16.067V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3698 30.0782H42.1599V14.0034C42.1599 10.9584 44.7767 8.49453 48.019 8.49453C51.2613 8.49453 53.8808 10.9662 53.8808 14.0034V30.0782H62.6682V14.0034C62.6682 13.926 62.6682 13.8511 62.6682 13.7736C62.6682 6.16493 56.1104 0 48.0138 0C39.9172 0 33.3594 6.16493 33.3594 13.7736C33.3594 13.8511 33.3594 13.926 33.3594 14.0034L33.3698 30.0782Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndiz);
export default __webpack_public_path__ + "static/media/undiz.23e30a9cdda1d58fc105251384aaddd7.svg";
export { ForwardRef as ReactComponent };